import React, { useContext, useEffect } from 'react'
import { Outlet } from 'react-router'
import { StoresContext } from '@App/contexts'

const SongwriterCatalogLayout = () => {
    const { songwriterCatalogSearchStore } = useContext(StoresContext)
    useEffect(() => () => {
        songwriterCatalogSearchStore.destroyWorksRightsHolderPaginationInfo()
        songwriterCatalogSearchStore.destroyCurrentPage()
        songwriterCatalogSearchStore.destroyWorksRightsHolder()
        songwriterCatalogSearchStore.destroyPagination()
    })

    return (
        <>
            <Outlet />
        </>
    )
}

export default SongwriterCatalogLayout
